import { createFileRoute } from "@tanstack/react-router";
import { noindexHead } from "@/lib/seo";

export const Route = createFileRoute("/soundkits/$SOUNDKIT_ID")({
  component: RouteComponent,
  head: () => noindexHead("Sound Kit | Lutely"),
});

function RouteComponent() {
  return <div>Hello "/soundkits/2SOUNDKIT_ID"!</div>;
}
